export default "__VITE_ASSET__DmrojE_3__"